<div class="fill-width flex flex-row flex-wrap gap-[8px] justify-start items-start">
  <ng-template #dynamicStructureComponentContainer></ng-template>
</div>
